import { useFormikContext } from 'formik'

import { Box, Flex } from 'app/components/design-system-components'
import ButtonWithLoading from 'app/components/design-system-components/ButtonWithLoading'
import type { RentalHistoryFormValues } from 'app/profile/renter/refactor_rental_history/components/RentalHistoryForm/types'

interface FormActionsProps {
  isLoading: boolean
  canSubmit: boolean
  submitError?: string
  onSubmitForm: () => void
}

/**
 * Form actions component
 * Handles form submission and reset actions
 */
export const FormActions = ({
  isLoading,
  canSubmit,
  submitError,
  onSubmitForm,
}: FormActionsProps) => {
  const formik = useFormikContext<RentalHistoryFormValues>()
  return (
    <Box
      borderTop="1px solid"
      borderColor="gray200"
      paddingTop={4}
      marginTop={6}
    >
      <Flex justifyContent="flex-end" alignItems="center">
        {submitError && (
          <Box color="error" fontSize="sm" marginRight={3}>
            {submitError}
          </Box>
        )}

        <ButtonWithLoading
          variant="primary"
          loading={isLoading}
          disabled={!canSubmit}
          onClick={onSubmitForm}
        >
          {formik.values.id ? 'Update Rental History' : 'Save Rental History'}
        </ButtonWithLoading>
      </Flex>
    </Box>
  )
}
